// French
const lang = {
    contact: 'Contact',
    born: 'Né en',
    bornIn: 'à',
    experience: 'Expérience professionnelle',
    education: 'Formation',
    skills: 'Compétences',
    projects: 'Projets',
    contributions: 'Contributions',
    about: 'À propos de moi',
    today: 'Aujourd\'hui',
    loading: 'Chargement en cours...',
    error: 'Une erreur s\'est produite'
};
export default lang;
